import { MdOutlineExpandMore } from "react-icons/md";
import { useContext, useState } from "react";
import { ChamadoChecklist, chamadoConfigType, chamadoConfigTypeSubitem } from "../../Filling/Types";
import { addTicketType } from "./ModalDetailPrint";
import { useTranslation } from "react-i18next";
import Anonimo from "../../../service/Anonimo";
import AttToken from "../../../helpers/attToken";
import { toast } from "react-toastify";
import Clients, { ClientType } from "../../../service/Clients";
import { chamadosAssociacoesType } from "../../Checklists/Modals/FormModal/FillingConfig";
import { UserContext } from "../../../context/UserContext";
import {
  Accordion,
  AccordionSummary,
  Button,
  createTheme,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Skeleton,
  Stack,
  TextField,
  ThemeProvider,
  Typography
} from "@mui/material";
import { ConjuntoType, PlaceType, UnidadeType } from "../../../service/Places";
import { ChecklistReportType } from "../../../service/Reports";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import ptBR from 'date-fns/locale/pt-BR';
import { trackEventMatomo } from "../../../helpers/matomo";
import QueryFn from "../../../helpers/QueryFn";
import HeaderModal from "../../HeaderModal/HeaderModal";
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';

type props = {
  chamado: ChamadoChecklist
  index: number,
  setChamados: Function,
  chamados: ChamadoChecklist[],
};

const queryFn = new QueryFn();
const anonimoService = new Anonimo();
const clienteService = new Clients();

function ChamadoCard({ chamado, index, setChamados, chamados }: props) {
  const [instrucao, setInstrucao] = useState(chamado.textChamado || '');
  const [data, setData] = useState<Date | number | undefined>(chamado.dateChamado as number || undefined);
  const { t } = useTranslation('translation');
  const [expand, setExpand] = useState<boolean>(false);

  const { userData } = useContext(UserContext);

  const getMuiTheme = () => createTheme({
    components: {
      MuiInputBase: {
        styleOverrides: {
          input: {
            textAlign: 'center',
            width: 110,
            maxWidth: 110,
            margin: 50
          }
        }
      },
    },
  });

  return (
    <Accordion style={{ width: '100%' }} expanded={expand} key={index}>
      <AccordionSummary
        expandIcon={<MdOutlineExpandMore onClick={() => {
          setExpand(!expand);
          trackEventMatomo('Modal abertura de chamado logado', 'click', 'acordeon', 'abre/fecha');
        }} color="#18A689" />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography variant="h6" color='textSecondary'>
          {chamado.selecionado ? chamado.selecionado.nome : t('Reports.modalDetailP.nameNotFound')}
        </Typography>
      </AccordionSummary>
      <Stack
        direction="column"
        justifyContent="flex-start"
        alignItems="stretch"
        spacing={1}
      >

        <TextField
          fullWidth
          multiline
          rows={4}
          label={t('Reports.modalDetailP.callInstructions')}
          onClick={() => trackEventMatomo('Modal de visualização de form', 'click', 'textarea', 'edita valor')}
          value={instrucao}
          onChange={(e) => {
            setInstrucao(e.target.value);
            chamados[index].textChamado = e.target.value;
            setChamados([...chamados]);
          }}
          disabled={!chamado.adicionadoApos}
        />
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          <ThemeProvider theme={getMuiTheme()}>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
              <DesktopDatePicker
                disabled={!chamado.adicionadoApos}
                slotProps={{
                  textField: {
                    required: true,
                  },
                  actionBar: {
                    actions: ['clear'],
                  },
                  field: {
                    readOnly: true,
                  },
                }}
                localeText={{
                  clearButtonLabel: 'Limpar',
                }}
                minDate={new Date(Date.now())}
                format='dd/MM/yyyy'
                label={t('Reports.modalDetailP.callDeadline')}
                value={data === undefined ? undefined : new Date(data)}
                onChange={(newValue) => {
                  trackEventMatomo('Modal de visualização de form', 'click', 'datepicker', 'edita data');
                  setData(newValue?.getTime());
                  chamados[index].dateChamado = newValue?.getTime();
                  setChamados([...chamados]);
                }}
              />
            </LocalizationProvider>
          </ThemeProvider>
          {userData.migrado && <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">{t('Reports.modalDetailP.priority')}</InputLabel>
            <Select
              disabled={!chamado.adicionadoApos}
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label={t('Reports.modalDetailP.priority')}
              value={chamados[index]?.prioridade}
              onClick={() => trackEventMatomo('Modal de visualização de form', 'click', 'select', 'seleciona valor')}
              defaultValue={chamados[index]?.prioridade}
              onChange={(e) => {
                const prioridade = e.target.value as 'alta' | 'media' | 'baixa';
                chamados[index].prioridade = prioridade;
                setChamados([...chamados]);
              }}
            >
              <MenuItem value="alta">{t('Reports.modalDetailP.high')}</MenuItem>
              <MenuItem value="media">{t('Reports.modalDetailP.medium')}</MenuItem>
              <MenuItem value="baixa">{t('Reports.modalDetailP.low')}</MenuItem>
            </Select>
          </FormControl>}
        </Stack>
      </Stack>
      <div style={{ padding: '10px' }}>
        {data === undefined && <span
          style={{
            width: '100%',
            justifyContent: 'center',
            display: 'flex',
            color: 'red',
            fontWeight: 700,
            fontSize: '12px'
          }}>
          {t('Reports.modalDetailP.openingDateRequired')}
        </span>}
      </div>
    </Accordion>
  );
}

type ModalEditTicketsProps = {
  chamados: ChamadoChecklist[],
  open: boolean,
  setOpen: Function,
  currentElement: addTicketType,
  chamadosConfig: chamadoConfigTypeSubitem | chamadoConfigType,
  setChamados: Function,
  ClearAndExit: Function,
  formId: string,
  inicio: number,
  chamadosObj: ChamadoChecklist[] | undefined,
  selected: ChecklistReportType
};

export default function ModalEditTicketsAfter({
  chamados,
  open,
  setOpen,
  currentElement,
  chamadosConfig,
  setChamados,
  formId,
  inicio,
  selected
}: ModalEditTicketsProps) {
  const { t } = useTranslation('translation');
  const [openModalConfirm, setOpenModalConfirm] = useState(false);

  const filterFunction = (index: number) => {
    setChamados((prev: ChamadoChecklist[]) => {
      return prev.filter((_e, i) => i !== index);
    });
  };

  return (
    <div className={`modal ${open ? 'is-active' : ''}`}>
      {openModalConfirm
        && <ConfirmationModal
          open={openModalConfirm}
          setOpen={setOpenModalConfirm}
          formId={formId}
          inicio={inicio}
          itemId={currentElement?.itemIndex as number}
          subId={currentElement?.subItemIndex as number}
          chamados={chamados}
          close={setOpen}
          setChamados={setChamados}
          selected={selected}
        />}
      <div className="modal-background" onClick={() => setOpen()} />
      <div className="modal-card">
        <HeaderModal headerTitle="Abertura de chamados" close={setOpen} />
        <section className="modal-card-body">
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">{t('preenchimento.addCall')}</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label={t('preenchimento.addCall')}
              onClick={() => trackEventMatomo('Modal de visualização de form', 'click', 'select', 'seleciona valor')}
              defaultValue={""}
              onChange={(event) => {
                const chamado = JSON.parse(event.target.value);
                chamados.push({ selecionado: chamado, adicionadoApos: true, prioridade: 'baixa' });
                setChamados([...chamados]);
                event.target.value = "";
              }}
            >
              <MenuItem value="" disabled>{t('select')}</MenuItem>
              {
                chamadosConfig.tipoChamado?.map(e => <MenuItem value={JSON.stringify(e)}>{e.nome}</MenuItem>)
              }
            </Select>
          </FormControl>
          <Stack
            sx={{ marginTop: '10px' }}
            direction="column"
            justifyContent="flex-start"
            alignItems="stretch"
            spacing={1}
          >
            {chamados?.map((e, i) => (
              <Stack
                width='100%'
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <ChamadoCard
                  chamado={e}
                  index={i}
                  setChamados={setChamados}
                  chamados={chamados}
                />
                {e.adicionadoApos &&
                  <IconButton>
                    <DeleteIcon
                      fontSize="large"
                      color='error'
                      onClick={() => {
                        filterFunction(i);
                      }} />
                  </IconButton>
                }
              </Stack>
            ))}
          </Stack>
        </section>
        <footer className="modal-card-foot">
          <div className="buttons">
            <Button
              disabled={!chamados?.every(e => e.dateChamado)}
              className="button is-success"
              onClick={() => {
                trackEventMatomo('Modal de visualização de form', 'click', 'button', 'salva');
                setOpenModalConfirm(true);
              }}
              endIcon={<SaveIcon />}>{t('save')}</Button>
          </div>
        </footer>
      </div>
    </div>
  );
}

type confirmationProps = {
  formId: string,
  inicio: number,
  itemId: number | boolean,
  subId: number | boolean,
  chamados: ChamadoChecklist[] | undefined,
  close: Function,
  setChamados: Function,
  selected: ChecklistReportType,
  open: boolean,
  setOpen: Function
};

function ConfirmationModal({
  open,
  setOpen,
  formId,
  inicio,
  itemId,
  subId,
  chamados,
  close,
  setChamados,
  selected
}: confirmationProps) {
  const ocultos = selected.camposOcultos;

  const { t } = useTranslation('translation');
  const [loading, setLoading] = useState(false);
  const [chamadoAssociacoes, setChamadoAssociacoes] = useState<chamadosAssociacoesType | null>({
    cliente: ocultos ? ocultos.cliente ? ocultos.cliente === "all" ? null : ocultos.cliente || null : null : null,
    local: ocultos ? ocultos.local ? ocultos.local === "all" ? null : ocultos.local || null : null : null,
    conjunto: ocultos ? ocultos.conjunto ? ocultos.conjunto === "all" ? null : ocultos.conjunto || null : null : null,
    unidade: ocultos ? ocultos.unidade ? ocultos.unidade === "all" ? null : ocultos.unidade || null : null : null,
  });

  const { hierarchyLabel, userData } = useContext(UserContext);

  const ArrumaChecklistsApos = () => {
    const newChamados = chamados?.map(e => {
      if (e.adicionadoApos) delete e.adicionadoApos;
      return e;
    });
    newChamados && setChamados([...newChamados]);
  };

  const { data: hierarquia, isLoading } = queryFn.useFetch('GET_HIERARCHY',
    async () => {
      try {
        const token = await AttToken();
        if (token) {
          const result = await clienteService.getAllHierarchy(token);
          return result;
        }
      } catch (error) {
        console.error(error);
      }
    }
  );

  const findName = (key: 'clientes' | 'conjuntos' | 'locais', id: string): string => {
    const selected = hierarquia
      ? hierarquia[key].find((el: ConjuntoType | ClientType | PlaceType) => el.id === id)
      : { nome: t('Reports.modalDetailP.nameNotFound'), id: 'A' };
    return selected
      ? selected.nome
      : t('Reports.modalDetailP.nameNotFound');
  };

  return (

    <div className={`modal ${open ? 'is-active' : ''}`}>
      <div className="modal-background" />
      <div className="modal-card">
        <div className="modal-card-body">
          {userData.migrado
            && <Typography
              variant="body1"
              textAlign='center'
              fontWeight='bold'>
              {t('Reports.modalDetailP.hierarchyConfirmation')}
            </Typography>}
          {userData.migrado
            ? <>
              <Typography variant="body2" textAlign='center'>{t('Reports.modalDetailP.hierarchyConfiguration')}</Typography>
              <Stack
                direction="column"
                justifyContent="flex-start"
                alignItems="stretch"
                spacing={1}
              >
                {isLoading
                  ? <>
                    <Skeleton variant="text" />
                    <Skeleton variant="rounded" height={40} />
                    <Skeleton variant="rounded" height={40} />
                    <Skeleton variant="rounded" height={40} />
                    <Skeleton variant="rounded" height={40} />

                  </>
                  : <>
                    {chamadoAssociacoes
                      && chamadoAssociacoes.cliente
                      && <Typography
                        variant="body2"
                        color='textSecondary'
                        fontWeight='bold'
                        style={{
                          wordBreak: 'break-word',
                          backgroundColor: '#FFE08A',

                        }}>
                        {
                          chamadoAssociacoes.cliente && !chamadoAssociacoes.local
                            ? `${t('Reports.modalDetailP.teamsServingAll')} ${hierarchyLabel.conjunto} ${t('Reports.modalDetailP.ofAll')} ${hierarchyLabel.local} ${t('Reports.modalDetailP.of')} ${hierarchyLabel.cliente} "${findName('clientes', chamadoAssociacoes.cliente)}" ${t('Reports.modalDetailP.willReceiveCalls')}`
                            : chamadoAssociacoes.cliente && chamadoAssociacoes.local && !chamadoAssociacoes.conjunto
                              ? `${t('Reports.modalDetailP.teamsServingAll')} ${hierarchyLabel.conjunto} ${t('Reports.modalDetailP.of')} ${hierarchyLabel.local} "${findName('locais', chamadoAssociacoes.local)}" ${t('Reports.modalDetailP.willReceiveCalls')}`
                              : chamadoAssociacoes.cliente && chamadoAssociacoes.local && chamadoAssociacoes.conjunto
                                ? `${t('Reports.modalDetailP.teamsServingSpecific')} ${hierarchyLabel.conjunto} "${findName('conjuntos', chamadoAssociacoes.conjunto)}" ${t('Reports.modalDetailP.willReceiveCalls')}`
                                : ('')
                        }
                      </Typography>}
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">{hierarchyLabel.cliente}</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label={hierarchyLabel.cliente}
                        onClick={() => trackEventMatomo('Modal de visualização de form', 'click', 'select', 'seleciona valor')}
                        onChange={(e) => {
                          const clienteId = e.target.value;
                          setChamadoAssociacoes({ cliente: clienteId, conjunto: null, local: null, unidade: null });
                        }}
                        value={chamadoAssociacoes ? chamadoAssociacoes.cliente || "" : ""}
                      >
                        {hierarquia.clientes && hierarquia.clientes.map((cl: ClientType) => (
                          <MenuItem value={cl.id}>{cl.nome}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">{hierarchyLabel.local}</InputLabel>
                      <Select
                        onClick={() => trackEventMatomo('Modal de visualização de form', 'click', 'select', 'seleciona valor')}
                        onChange={(e) => {
                          const id = e.target.value;
                          setChamadoAssociacoes(prev => prev && { ...prev, local: id, conjunto: null, unidade: null });
                        }}
                        value={chamadoAssociacoes ? chamadoAssociacoes.local || "" : ""}
                        disabled={!chamadoAssociacoes || !chamadoAssociacoes.cliente}
                        label={hierarchyLabel.local}
                      >
                        {chamadoAssociacoes && chamadoAssociacoes.cliente && hierarquia.locais &&
                          hierarquia.locais.filter((cl: PlaceType) => cl.cliente === chamadoAssociacoes.cliente).map((cl: PlaceType) => (
                            <MenuItem value={cl.id}>{cl.nome}</MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">{hierarchyLabel.conjunto}</InputLabel>
                      <Select
                        onClick={() => trackEventMatomo('Modal de visualização de form', 'click', 'select', 'seleciona valor')}
                        onChange={(e) => {
                          const id = e.target.value;
                          setChamadoAssociacoes(prev => prev && { ...prev, conjunto: id, unidade: null });
                        }}
                        value={chamadoAssociacoes ? chamadoAssociacoes.conjunto || "" : ""}
                        disabled={!chamadoAssociacoes || !chamadoAssociacoes.local}
                        label={hierarchyLabel.conjunto}
                      >
                        {chamadoAssociacoes
                          && chamadoAssociacoes?.local
                          && hierarquia?.conjuntos
                          && hierarquia?.conjuntos.filter((cnj: ConjuntoType) => cnj.local === chamadoAssociacoes.local)?.map((cnj: ConjuntoType) => (
                            <MenuItem value={cnj.id}>{cnj.nome}</MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">{hierarchyLabel.unidade}</InputLabel>
                      <Select
                        onClick={() => trackEventMatomo('Modal de visualização de form', 'click', 'select', 'seleciona valor')}
                        onChange={(e) => {
                          const id = e.target.value;
                          setChamadoAssociacoes(prev => prev && { ...prev, unidade: id });
                        }}
                        value={chamadoAssociacoes ? chamadoAssociacoes.unidade || "" : ""}
                        disabled={!chamadoAssociacoes || !chamadoAssociacoes.conjunto}
                        label={hierarchyLabel.unidade}
                      >
                        {chamadoAssociacoes
                          && chamadoAssociacoes?.conjunto
                          && hierarquia.unidades
                          && hierarquia?.unidades?.filter((uni: UnidadeType) => uni.conjunto === chamadoAssociacoes.conjunto)?.map((uni: UnidadeType) => (
                            <MenuItem value={uni.id}>{uni.nome}</MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </>
                }
              </Stack>
            </>
            : (
              <Typography fontWeight='bold' variant="body1">{t('Reports.modalDetailP.areYouSure')}</Typography>
            )}
        </div>
        <footer className="modal-card-foot">
          <Stack
            width='100%'
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={1}
          >
            <Button
              endIcon={<CheckCircleOutlineIcon />}
              disabled={loading || isLoading}
              className="button is-success"
              onClick={async () => {
                trackEventMatomo('Modal de visualização de form', 'click', 'select', 'salva');
                setLoading(true);
                toast.warn(`${t('formDetails.savingTickets')}`);
                const token = await AttToken();
                if (token) {
                  await anonimoService.editaChamadoExecucao(token, formId, inicio, chamados as ChamadoChecklist[], itemId, subId, {
                    cliente: chamadoAssociacoes?.cliente || 'all',
                    local: chamadoAssociacoes?.local || 'all',
                    conjunto: chamadoAssociacoes?.conjunto || 'all',
                    unidade: chamadoAssociacoes?.unidade || 'all',
                  });
                  toast.success(`${t('Reports.modalDetailP.callsTriggered')}`);
                  ArrumaChecklistsApos();
                  setOpen(false);
                  close();
                } else toast.error(`${t('Reports.modalDetailP.tokenNotFound')}`);
                setLoading(false);
              }}>
              {t('yes')}
            </Button>
            <Button
              endIcon={<DoDisturbIcon />}
              className="button is-danger"
              onClick={() => setOpen(false)}
              disabled={loading || isLoading}>
              {t('no')}
            </Button>
          </Stack>
        </footer>
      </div>
    </div>
  );
}
